import { Collapse, Tag, Steps, Space, Typography, List } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
} from "../../../../Components/Items";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text } = Typography;

const thStyle = { padding: '4px 8px', textAlign: 'left', borderBottom: '1px solid #f0f0f0', color: '#888', fontWeight: 600, fontSize: 12 };
const tdStyle = { padding: '4px 8px', borderBottom: '1px solid #f0f0f0', fontSize: 13 };

// De peor a mejor, para quedarnos con el avance mas atrasado de la cadena.
const ORDEN_RECEPCION = { sinOrdenCompra: 0, sinRecibir: 1, recibidoParcial: 2, recibidoCompleto: 3 };

class RastrearRequisicion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    requisicionesHtml: <p>No se encontro ninguna requisicion</p>,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "ventas/rastrearRequisicion",
        { id: this.props.id, pedido: this.props.pedido, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) return;

        const historiales =
          res.data?.cadenas ||
          res.data?.cadenasPorRequisicion ||
          res.data?.historial ||
          [];

        if (!Array.isArray(historiales) || historiales.length === 0) {
          this.setState({
            requisicionesHtml: (
              <Text type="secondary">Sin requisiciones para mostrar.</Text>
            ),
          });
          return;
        }

        const requisicionesHtml = (
          <Collapse
            accordion
            defaultActiveKey={String(historiales?.[0]?.requisicionInicial)}
            style={{ background: "transparent" }}
          >
            {historiales.map((h) => {
              const reqIni = h.requisicionInicial || {};
              const cadena = h.cadena || [];

              const totalOCs = cadena.reduce(
                (acc, step) => acc + (step?.ordenesCompra?.length || 0),
                0
              );

              // El peor avance de la cadena es la respuesta honesta sin tener que expandir.
              const recepcionPeor = cadena
                .map((step) => step?.recepcion)
                .filter(Boolean)
                .sort((a, b) => ORDEN_RECEPCION[a.estado] - ORDEN_RECEPCION[b.estado])[0];

              const folioRequisicion = cadena[0]?.folio;

              const header = (
                <Space size={8} wrap>
                  <Text strong>
                    {folioRequisicion
                      ? `Requisición ${folioRequisicion}`
                      : "Requisición inicial"}
                  </Text>
                  <Tag color="blue">{`OCs: ${totalOCs}`}</Tag>
                  {recepcionPeor && (
                    <Tag color={recepcionPeor.color || undefined}>
                      {recepcionPeor.etiqueta}
                    </Tag>
                  )}
                </Space>
              );

              const panelKey = String(reqIni || Math.random());

              return (
                <Collapse.Panel key={panelKey} header={header}>
                  <Steps direction="vertical" current={Math.max((cadena?.length || 1) - 1, 0)}>
                    {cadena.map((step, idx) => (
                      <Steps.Step
                        key={step._id || `${panelKey}-${idx}`}
                        title={
                          <Space size={8} wrap>
                            <Text strong>{step.folio || step._id}</Text>
                            <Tag color={step.estatusColor}>{step.estatus || "SIN ESTATUS"}</Tag>
                            {step.recepcion && (
                              <Tag color={step.recepcion.color || undefined}>
                                {step.recepcion.etiqueta}
                              </Tag>
                            )}
                            <Text type="secondary">
                              {step.createdAt
                                ? moment(step.createdAt).format("DD/MM/YYYY HH:mm")
                                : "-"}
                            </Text>
                          </Space>
                        }
                        description={
                          <div style={{ marginTop: 4 }}>
                            <div style={{ marginBottom: 8 }}>
                              <Text>{step.descripcion}</Text>
                              {step.creadoPor?.nombre && (
                                <>
                                  {" · "}
                                  <Text type="secondary">por {step.creadoPor.nombre}</Text>
                                </>
                              )}
                            </div>

                            {step.ordenesCompra?.length > 0 ? (
                              <List
                                size="small"
                                dataSource={step.ordenesCompra}
                                renderItem={(oc) => (
                                  <List.Item style={{ flexDirection: 'column', alignItems: 'flex-start', opacity: oc.agrupada ? 0.65 : 1 }}>
                                    <Space split={<span>·</span>} wrap>
                                      <Text strong>OC: {oc.folio || oc._id}</Text>
                                      {oc.proveedorNombre && <Text>{oc.proveedorNombre}</Text>}
                                      <Tag color={oc.estatusFacturaColor}>{oc.estatusFactura || "—"}</Tag>
                                      <Tag color={oc.estatusColor}>{oc.estatus || "—"}</Tag>
                                      <Text type="secondary">
                                        {oc.createdAt
                                          ? moment(oc.createdAt).format("DD/MM/YYYY")
                                          : ""}
                                      </Text>
                                    </Space>

                                    {oc.agrupada && oc.agrupadaEnFolio && (
                                      <Text type="secondary" style={{ fontSize: 12 }}>
                                        Agrupada en OC {oc.agrupadaEnFolio} — el material llega en esa orden
                                      </Text>
                                    )}

                                    {oc.sustituyeA?.length > 0 && (
                                      <Text type="secondary" style={{ fontSize: 12 }}>
                                        Proviene de agrupar: {oc.sustituyeA.map((o) => o.folio).join(", ")}
                                      </Text>
                                    )}

                                    {!oc.agrupada && oc.insumosDetalle?.length > 0 && (
                                      <table style={{ width: '100%', marginTop: 6, fontSize: 12, borderCollapse: 'collapse' }}>
                                        <thead>
                                          <tr style={{ background: '#fafafa' }}>
                                            <th style={thStyle}>Insumo</th>
                                            <th style={{ ...thStyle, textAlign: 'right' }}>Pedido</th>
                                            <th style={{ ...thStyle, textAlign: 'right' }}>Recibido</th>
                                            <th style={{ ...thStyle, textAlign: 'right' }}>Pendiente</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {oc.insumosDetalle.map((ins, i) => (
                                            <tr key={i}>
                                              <td style={tdStyle}>{ins.clave ? `${ins.clave} - ` : ''}{ins.nombre}</td>
                                              <td style={{ ...tdStyle, textAlign: 'right' }}>{ins.pedido}</td>
                                              <td style={{ ...tdStyle, textAlign: 'right', color: ins.recibido > 0 ? '#52c41a' : undefined }}>
                                                {ins.recibido}
                                              </td>
                                              <td style={{ ...tdStyle, textAlign: 'right', color: ins.pendiente > 0 ? '#fa8c16' : '#52c41a', fontWeight: ins.pendiente > 0 ? 600 : 400 }}>
                                                {ins.pendiente}
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    )}
                                  </List.Item>
                                )}
                              />
                            ) : null}
                          </div>
                        }
                        status={idx === (cadena?.length || 1) - 1 ? "finish" : "process"}
                      />
                    ))}
                  </Steps>
                </Collapse.Panel>
              );
            })}
          </Collapse>
        );

        this.setState({ requisicionesHtml });
      });
    this.setState({ loading: false });
  }

  cerrarRastrearRequisicion() {
    this.props.cerrarRastrearRequisicion();
  }

  render() {
    return (
      <>
        <ModalItem
          title={"Requisiciones" + (this.props.pedido ? " del pedido" : " de la venta")}
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarRastrearRequisicion.bind(this)}
          paddingTop
          zIndex={1}
        >
          {this.state.requisicionesHtml}
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(RastrearRequisicion);
